import React from 'react';
import './Main.scss';

class Main extends React.Component {
  render () {
    return (
      <div className="main__container">
      </div>
    )
  }
}

export default Main;
